<template>
  <div id="app">
	<v-app>
		<TopLine />
		<v-container py-0 style="max-width:1125px;">
			<v-layout column fill-height>
				<v-flex fill-height>
					<Logo />
					<Navigation />
					<v-content fill-height>
						<v-container px-0>
							<router-view></router-view>
						</v-container>
					</v-content>
				</v-flex>
				<v-flex>
					<Footer />
				</v-flex>
			</v-layout>
		</v-container>
	</v-app>
  </div>
</template>

<script>
import Logo from './components/Logo'
import TopLine from './components/TopLine'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
export default {
  name: 'app',
  data () {
    return {
	
    }
  },
  components:{
	Footer,
	Logo,
	TopLine,
	Navigation
  }
}
</script>

<style>
.application.theme--light{
	background-color:white;
}
.navbar-list-tile:hover{
	background-color: rgb(191, 87, 0) !important;
}
.list__group__header:hover{
	background-color:#a04400 !important;
	color:white;
}
.list__group .navbar-list-tile:hover a{
	color:white;
}
.navbar-list-tile:hover div{
	color:white;
}
.list__group__header:hover i{
	color:white;
}
.list__group__header i{
	background-color:transparent;
}
.navbar-list-tile, .list__group__header, .list__group__header i{
	color:black;
}
.menu__activator--active div{
	background-color:#a04400 !important;
	color:white !important;
}
.carousel-text-xs{
	font-size:17px;
	font-family: "open_sans", sans-serif;
	font-weight: 400;
	text-decoration-style: solid;
	text-transform:none;
	position:absolute;
	bottom:0;
	z-index:1;
	width:100%;
	background-color:#f8f8f8;
	border-top:1px solid #e1ddd2;
}
.carousel-text{
	font-size:27px;
	font-family: "open_sans", sans-serif;
	font-weight: 400;
	text-decoration-style: solid;
	text-transform:none;
}
.carousel-subtext{
	font-size:17px;
	font-family: "open_sans", sans-serif;
	font-weight: 400;
	text-decoration-style: solid;
	text-transform:none;
}
.carousel-image{
	width:auto;
	height:100%;
	max-height:50vw;
	min-width:auto;
	display:inline-block;
	position:absolute;
	left:0;
}

.carousel{
	max-height:50vw;
	width:auto;
	box-shadow: inherit;
	height:400px;
}
.jumbotron__image{
    width:auto;
	height:100%;
	max-height:50vw;
	min-width:auto;
}
.jumbotron__wrapper{
	background-color:#f8f8f8;
	border: 1px solid #e1ddd2;
}
.carousel__left{
	background-color:rgba(0,0,0,0.25);
	margin-left:-5px;
}
.carousel__right{
	background-color:rgba(0,0,0,0.25);
	margin-right:-5px;
}
.carousel__left div, .carousel__right div {
	width:25px;
	height:60px;
}
.carousel__controls{
	height:30px;
	background-color:transparent;
}
.carousel .jumbotron{
	padding-bottom:30px;
}
.carousel__controls__item div{
	color:#cccccc;
}
.carousel__controls__item div i{
	font-size:14px !important;
}
.carousel__controls__item--active div{
	color:#333333;
}

.tmplt-title{
	font-size:48px;
	font-family: 'open_sans', sans-serif;
	color: #493425;
	font-weight: bold;
	border-bottom: 4px solid #bf5700;
	padding-left:10px;
}
.tmplt-content{
	font-family: 'open_sans', sans-serif;
	font-size:17px;
	font-weight:400;
	color: #515151 !important;
	line-height:28px;
}
.tmplt-content h2{
	font-size:36px;
	font-weight:500;
	margin-bottom:25px;
	color: #333333;
	width:100%;
	padding-top:35px;
	line-height:normal;
}

.tmplt-content a{
	text-decoration: none;
	color: #BF5700;
}
.tmplt-content a i{
	color: #BF5700 !important;
}
.tmplt-content a:hover{
	text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/App.vue